import { render } from "./pay.vue?vue&type=template&id=32f2bc5a&scoped=true&ts=true"
import script from "./pay.vue?vue&type=script&lang=ts"
export * from "./pay.vue?vue&type=script&lang=ts"

import "./pay.vue?vue&type=style&index=0&id=32f2bc5a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_mpay_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f2bc5a"]])

export default __exports__